import { RouteObject } from 'react-router-dom';
import { MaintenanceGuard } from '../MaintenanceGuard';
import ApplicantLayout from '../components/layout/ApplicantLayout';
import { ApplicantHome } from '../pages/applicant/Home';
import { PreWorkWizardContainer } from '../pages/applicant/PreWorkWizard';
import { PreWorkContextWizardContainer } from '../pages/applicant/PreWorkWizard/PreWorkContextPolicy';
import { APPLICANT_HOME, PRE_WORK, PRE_WORK_CONTEXT } from '../shared/Routes';

export const ApplicantRoutes: RouteObject[] = [
	{
		element: <MaintenanceGuard component={<ApplicantLayout />} />,
		children: [
			{
				path: APPLICANT_HOME,
				element: <MaintenanceGuard component={<ApplicantHome />} />,
			},
			{
				path: PRE_WORK,
				element: <MaintenanceGuard component={<PreWorkWizardContainer />} />,
			},
			{
				path: PRE_WORK_CONTEXT,
				element: (
					<MaintenanceGuard component={<PreWorkContextWizardContainer />} />
				),
			},
		],
	},
];
